<template>
    <v-content>
      <v-container fluid >
        <v-row no-gutters>
            <v-col cols="12">
                <v-card class="pa-2" raised outlined tile>
                  <h1 class="mx-4 mb-8">
                    {{ individualadditionalpage.page_names[0].page_name }}
                  </h1>

                  <!-- FAQ PAGE IS GENERATED HERE -->
                  <template  v-if="(individualadditionalpage.page_type=='faq')">
                    <v-expansion-panels variant="accordion" v-model="panel" width="50%">
                      <v-expansion-panel
                        v-for="(page, index) in individualadditionalpage.page_contents" :key="index" :value="page.page_title">
                        <v-card
                          color="#f7f7f7"
                        >
                        <v-expansion-panel-header class="faq-card-title font-weight-bold pa-6">
                        {{ individualadditionalpage.page_names.page_name }}
                          {{page.rank_number ? page.rank_number : page.content_number}} ) {{ page.page_title }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-html='page.page_content'>
                          </div>
                        </v-expansion-panel-content>
                        </v-card>
                      </v-expansion-panel>
                    </v-expansion-panels>

                  </template>

                  <!-- FAQ PAGE ENDS HERE -->


                  <!-- GLOSSARY PAGE STARTS HERE -->
                  
                <template  v-else-if="(individualadditionalpage.page_type=='glossary')">
                  
                  <div class="row ml-2">
                    <div class="col-md-12">
                      <span style="background-color: #1976d2 !important; border-radius:5px">
                        <v-btn v-for="button in glossaryButtons" :key="button.id" @click="searchGlossarItem(button.label)" color="primary" class="pa-0" min-width="39px">
                          {{ button.label }}
                        </v-btn>
                      </span>
                    </div>
                    <div class="col-md-12">
                    <v-btn color="red" @click="clearGlossarySearch()" class="mt-2 white--text" v-if="selectedTitle">
                      <v-icon color="white">mdi-cancel </v-icon> {{'Reset' | translate}}
                    </v-btn>
                    </div>
                  </div>

                  <div class="row mt-4" >
                    <div class="col-md-4">
                      <div class="row" >

                        <div class="col-md-12">
                          <template>
                            <v-card
                                class="mx-auto"
                                max-width="300"
                                tile
                                style="max-height: 700px; overflow-y: scroll"
                              >
                              <v-list>
                                  <v-subheader>
                                    <v-autocomplete
                                      v-model="selectedTitle"
                                      :label="'Search' | translate"
                                      :items="glossaryItems"
                                      item-value="page_title"
                                      item-text="page_title"
                                      variant="outlined"
                                      prepend-inner-icon="mdi-magnify"
                                      @change="searchGlossarItemByTitle()"
                                     ></v-autocomplete>
                                  </v-subheader>
                                  
                                  <v-list-item-group
                                    v-model="selectedItem"
                                    color="primary"
                                  >
                                    <v-list-item
                                    v-for="itemdata in glossaryItems"
                                    :key="itemdata.page_title"
                                    >
                                      <v-list-item-content>
                                      <v-list-item-title @click=searchGlossarItemByTitle(itemdata.page_title)> {{ itemdata.page_title }}</v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-card>
                          </template>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-8" >
                        <v-card>
                          <template>
                              <v-card>
                                <div v-for="(page, index) in glossaryItems" :key="index">
                                    <v-card-title>{{ page.page_title }}</v-card-title>
                                    <v-card-text v-html='page.page_content'></v-card-text>
                                    <v-divider class="mx-4" v-if="(individualadditionalpage.page_type!='blank') && (index!=(individualadditionalpage.page_contents.length-1))"></v-divider>
                                </div>
                              </v-card>
                          </template>
                        </v-card>
                    </div>
                  </div>
                </template>
                <!-- GLOSSARY PAGE ENDS HERE -->

                  <template v-else>
                    <div v-for="(page, index2) in individualadditionalpage.page_contents" :key="index2">
                        <v-card-title>{{ page.page_title }}</v-card-title>
                        <v-card-text v-html='page.page_content'></v-card-text>
                        <v-divider class="mx-4" v-if="(individualadditionalpage.page_type!='blank') && (index2!=(individualadditionalpage.page_contents.length-1))"></v-divider>
                    </div>
                </template>

                </v-card>
            </v-col>
        </v-row>
      </v-container>
    </v-content>
  </template>
  
  <script>
  import {
    FETCH_INDIVIDUAL_ADDITIONAL_PAGE,
    PAGES_RESET_STATE
  } from "@/store/actions.type"
  import { mapGetters } from "vuex"
  import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
  import store from "@/store"
  
  export default {
      name:'Pages',
      async beforeRouteUpdate(to, from, next) {
          await store.dispatch(FETCH_INDIVIDUAL_ADDITIONAL_PAGE, to.params.slug +'?replace_content=true').then(resp => {
            if (resp.success) {
                store.commit(SET_LOADING, false)
            }
          })             
          
          return next();
      },
      async beforeRouteEnter(to, from, next) {  
          await store.dispatch(FETCH_INDIVIDUAL_ADDITIONAL_PAGE, to.params.slug +'?replace_content=true').then(resp => {
            if (resp.success) {
                store.commit(SET_LOADING, false)
                store.commit(SET_ROUTER_ENTER, false)
            }
          })         
          return next();
      },
      async beforeRouteLeave(to, from, next) {
          await store.dispatch(PAGES_RESET_STATE)
          next();
      },  
      computed: {
          ...mapGetters(["individualadditionalpage",'curLanguage']),
          language(){
              return this.$store.state.translations.curLanguage
          },
          glossaryButtons(){
            let glossaryButtons = null;
            if(this.language.lang_code=='en'){
              glossaryButtons = [
                { id: 'a', label: 'A' },
                { id: 'b', label: 'B' },
                { id: 'c', label: 'C' },
                { id: 'd', label: 'D' },
                { id: 'e', label: 'E' },
                { id: 'f', label: 'F' },
                { id: 'g', label: 'G' },
                { id: 'h', label: 'H' },
                { id: 'i', label: 'I' },
                { id: 'j', label: 'J' },
                { id: 'k', label: 'K' },
                { id: 'l', label: 'L' },
                { id: 'm', label: 'M' },
                { id: 'n', label: 'N' },
                { id: 'o', label: 'O' },
                { id: 'p', label: 'P' },
                { id: 'q', label: 'Q' },
                { id: 'r', label: 'R' },
                { id: 's', label: 'S' },
                { id: 't', label: 'T' },
                { id: 'u', label: 'U' },
                { id: 'v', label: 'V' },
                { id: 'w', label: 'W' },
                { id: 'x', label: 'X' },
                { id: 'y', label: 'Y' },
                { id: 'z', label: 'Z' },
              ];
            }
            else{
              glossaryButtons = [
                { id: '#', label: '#' },
                { id: 'a', label: 'A' },
                { id: 'ä', label: 'Ä' },
                { id: 'b', label: 'B' },
                { id: 'c', label: 'C' },
                { id: 'd', label: 'D' },
                { id: 'e', label: 'E' },
                { id: 'f', label: 'F' },
                { id: 'g', label: 'G' },
                { id: 'h', label: 'H' },
                { id: 'i', label: 'I' },
                { id: 'j', label: 'J' },
                { id: 'k', label: 'K' },
                { id: 'l', label: 'L' },
                { id: 'm', label: 'M' },
                { id: 'n', label: 'N' },
                { id: 'o', label: 'O' },
                { id: 'ö', label: 'Ö' },
                { id: 'p', label: 'P' },
                { id: 'q', label: 'Q' },
                { id: 'r', label: 'R' },
                { id: 's', label: 'S' },
                { id: 't', label: 'T' },
                { id: 'u', label: 'U' },
                { id: 'ü', label: 'Ü' },
                { id: 'v', label: 'V' },
                { id: 'w', label: 'W' },
                { id: 'x', label: 'X' },
                { id: 'y', label: 'Y' },
                { id: 'z', label: 'Z' },
              ];
            }
            return glossaryButtons;

          }
  
      }, 
      data: function() {
          return {
              pagetitle: null,
              pageId: null,   
              panel : null,
              selectedTitle: null,
          }
      },
    watch: {
      language () {
          this.getPageData()
      }
    }, 
    created() {
        this.pageId = this.individualadditionalpage.page_id
        this.pagetitle= this.individualadditionalpage.page_title
        this.originalglossaryItems = this.individualadditionalpage.page_contents;
        this.glossaryItems = this.individualadditionalpage.page_contents;
    },
      methods: {
          async getPageData(){
              await store.dispatch(FETCH_INDIVIDUAL_ADDITIONAL_PAGE, this.pageId +'?replace_content=true').then(resp => {
                if (resp.success) {
                    store.commit(SET_LOADING, false)
                }
              })   
          },
          searchGlossarItem(letter){
            letter = letter.toLowerCase();
            this.selectedTitle = letter;
            this.glossaryItems = this.originalglossaryItems;
            if(this.selectedTitle == '#'){
              this.glossaryItems = this.glossaryItems.filter(data=> /^\d/.test(data.page_title) ? (data.page_title.toLowerCase()).startsWith(Number(data.page_title.match(/^\d+/)[0])) : '' )
            }
            else{
              this.glossaryItems = this.glossaryItems.filter(data=> (data.page_title.toLowerCase()).startsWith(this.selectedTitle) )
            }
          
          },
          searchGlossarItemByTitle(title = null){
            if(title){
              this.selectedTitle = title;
            }
            if(this.selectedTitle){
              this.glossaryItems = this.originalglossaryItems;
              // this.glossaryItems = this.glossaryItems.filter(data=> (data.page_title.toLowerCase()) == this.selectedTitle.toLowerCase() || (data.page_content.toLowerCase()).includes(this.selectedTitle.toLowerCase() )
              this.glossaryItems = this.glossaryItems.filter(data=> (data.page_title.toLowerCase()) == this.selectedTitle.toLowerCase() )
            }
          },
          clearGlossarySearch(){
            location.reload();
          }
      }           
  }
  </script>

  <style scoped>

.faq-content-display{
	display:none;
}

  .faq-card-title:hover {
    background-color: #bbbbbb;
  }

  .v-expansion-panel-header--active{
    background-color: #bbbbbb;
  }


  </style>